import { useMutation } from '@tanstack/react-query'

import { updateSteeringMultistep } from '@/features/resource/endpoints/resources'
import type { ResourceSteeringMultistepSchemaType } from '@/features/resource/types'

export function useUpdateSteeringMultistepMutation(resourceID: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: ResourceSteeringMultistepSchemaType) => {
      const multistepStrategy = data.isMultistepResource ? data.multistepStrategy : null

      return updateSteeringMultistep(resourceID, data.isMultistepResource, multistepStrategy)
    },
  })

  return {
    updateSteeringMultistep: mutateAsync,
    ...mutationResult,
  }
}
